import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FormControl } from '@angular/forms';
import { SearchService, SEARCH_TYPE_CUENTA, SEARCH_TYPE_COLABORADOR, SEARCH_TYPE_MOTOR, SEARCH_TYPE_LABEL } from '../../../../services/search-service';
import { MdDialogRef, MdOptionSelectionChange, DateAdapter } from '@angular/material';

@Component({
  selector: 'app-etiqueta-autocomplete',
  templateUrl: './etiqueta-autocomplete.component.html',
  styleUrls: ['./etiqueta-autocomplete.component.scss']
})
export class EtiquetaAutocompleteComponent implements OnInit {

  // Etiquetas
  etiquetas = [];
  public etiquetasStateControl: FormControl;
  filteredEtiquetas: Observable<any>;
  selectedEtiquetas = [];
  @Input('singleValue') singleValue = false;  

  @Input() 
  set selection(selection) {
    // careful, copy the array in case you forgot to pass a copy instead of a reference
    this.selectedEtiquetas = selection.slice();
  }

  @Input()
  placeholder: string = 'Filtrar por Etiqueta';

  constructor(private searchService: SearchService) { 
    // Etiquetas
    this.etiquetasStateControl = new FormControl();
    this.filteredEtiquetas = this.etiquetasStateControl.valueChanges
        .startWith(null)
        .debounceTime(1000)
        .switchMap(value => {
          if ((value && value.length > 0) && (!this.singleValue || this.selectedEtiquetas.length == 0)){
            return this.searchService.searchAutocomplete(value, SEARCH_TYPE_LABEL);
          } else {
            return Observable.from([]);
          }
        })
        .map( value => {
          return value;
        });
  }

  ngOnInit() {
  }

  selectedEtiqueta(event: MdOptionSelectionChange, value: any) {
    if (this.singleValue && this.selectedEtiquetas.length > 0){
      return;
    }

    if (event.source.selected &&
          this.selectedEtiquetas.filter(v => v.Id === value.Id).length === 0) {
        this.selectedEtiquetas.push(value);
    }
  }

  removeEtiqueta(etiqueta){
    this.selectedEtiquetas.splice(this.selectedEtiquetas.findIndex(v => v.Id === etiqueta.Id), 1);
  }

  displayFn(value){
    return null;
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/autocomplete/etiqueta-autocomplete/etiqueta-autocomplete.component.ts